document.addEventListener('DOMContentLoaded', function() {
  const dataFilter = document.getElementById('data-filter');
  const validityFilter = document.getElementById('validity-filter');
  const priceFilter = document.getElementById('price-filter');
  const products = document.querySelectorAll('.card--holder');
  const noProductsMessage = document.querySelector('.no-products-message');
  const customSelects = document.querySelectorAll('.custom-select');
  const sortSelect = document.getElementById('sort-by');

  // Initialize sorting functionality
  if (sortSelect) {
    // Set initial sort value from URL
    const urlParams = new URLSearchParams(window.location.search);
    const sortValue = urlParams.get('sort_by');
    if (sortValue) {
      sortSelect.value = sortValue;
    }

    // Handle sort change
    sortSelect.addEventListener('change', function() {
      const selectedValue = this.value;
      const currentUrl = new URL(window.location.href);
      
      // Update or add the sort_by parameter
      currentUrl.searchParams.set('sort_by', selectedValue);
      
      // Navigate to the new URL
      window.location.href = currentUrl.toString();
    });
  }

  // Calculate max price from jsPrice elements
  let maxCollectionPrice = 0;
  products.forEach(product => {
    const jsPriceElement = product.querySelector('.jsPrice');
    if (jsPriceElement) {
      const priceText = jsPriceElement.textContent.trim();
      const numericPrice = parseFloat(priceText.replace(/[^0-9.]/g, ''));
      if (numericPrice > maxCollectionPrice) {
        maxCollectionPrice = numericPrice;
      }
    }
  });
  
  // Round up to nearest 1000
  maxCollectionPrice = Math.ceil(maxCollectionPrice / 1000) * 1000;

  // Create dynamic price ranges
  const priceRangeContainer = document.querySelector('.price-options');
  if (priceRangeContainer) {
    // Calculate range size and round it to nearest 1000
    let rangeSize = Math.ceil(maxCollectionPrice / 4);
    rangeSize = Math.ceil(rangeSize / 1000) * 1000;

    const ranges = [
      { min: 0, max: rangeSize },
      { min: rangeSize, max: rangeSize * 2 },
      { min: rangeSize * 2, max: rangeSize * 3 },
      { min: rangeSize * 3, max: maxCollectionPrice }
    ];

    ranges.forEach((range, index) => {
      const option = document.createElement('div');
      option.className = 'select-option';
      
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'radio';
      input.name = 'price-range';
      input.value = `${range.min}-${range.max}`;

      const span = document.createElement('span');
      if (index === 0) {
        span.textContent = `Up to ${range.max.toLocaleString()}`;
      } else if (index === ranges.length - 1) {
        span.textContent = `Over ${range.min.toLocaleString()}`;
      } else {
        span.textContent = `${range.min.toLocaleString()} - ${range.max.toLocaleString()}`;
      }

      label.appendChild(input);
      label.appendChild(span);
      option.appendChild(label);
      priceRangeContainer.appendChild(option);

      // Add change event listener to radio button
      input.addEventListener('change', function() {
        if (this.checked) {
          const [min, max] = this.value.split('-').map(Number);
          updatePriceRangeUI(min, max);
          filterProducts();
        }
      });
    });
  }

  // Initialize price range UI elements
  const rangeMin = document.querySelector('.range-min');
  const rangeMax = document.querySelector('.range-max');
  const inputMin = document.querySelector('.input-min');
  const inputMax = document.querySelector('.input-max');
  const progress = document.querySelector('.slider .progress');
  const clearRangeBtn = document.querySelector('.clear-range');
  const priceGap = 10;

  // Set initial values
  rangeMin.max = maxCollectionPrice;
  rangeMax.max = maxCollectionPrice;
  rangeMax.value = maxCollectionPrice;
  inputMax.value = maxCollectionPrice;

  // Add clear button functionality
  clearRangeBtn.addEventListener('click', function() {
    // Reset all radio buttons
    const priceRangeRadios = document.querySelectorAll('input[name="price-range"]');
    priceRangeRadios.forEach(radio => radio.checked = false);

    // Reset range and input values
    rangeMin.value = 0;
    rangeMax.value = maxCollectionPrice;
    inputMin.value = 0;
    inputMax.value = maxCollectionPrice;

    // Reset progress bar
    progress.style.left = "0%";
    progress.style.right = "0%";

    // Trigger filter update
    filterProducts();
  });

  // Function to update price range UI
  function updatePriceRangeUI(minVal, maxVal) {
    inputMin.value = minVal;
    inputMax.value = maxVal;
    rangeMin.value = minVal;
    rangeMax.value = maxVal;
    progress.style.left = (minVal / maxCollectionPrice) * 100 + "%";
    progress.style.right = 100 - (maxVal / maxCollectionPrice) * 100 + "%";
  }

  // Handle range input changes
  rangeMin.addEventListener('input', function() {
    const minVal = parseInt(rangeMin.value);
    const maxVal = parseInt(rangeMax.value);
    
    if (maxVal - minVal >= priceGap) {
      inputMin.value = minVal;
      progress.style.left = (minVal / maxCollectionPrice) * 100 + "%";
      uncheckPriceRangeRadios();
      filterProducts();
    } else {
      rangeMin.value = maxVal - priceGap;
    }
  });

  rangeMax.addEventListener('input', function() {
    const minVal = parseInt(rangeMin.value);
    const maxVal = parseInt(rangeMax.value);
    
    if (maxVal - minVal >= priceGap) {
      inputMax.value = maxVal;
      progress.style.right = 100 - (maxVal / maxCollectionPrice) * 100 + "%";
      uncheckPriceRangeRadios();
      filterProducts();
    } else {
      rangeMax.value = minVal + priceGap;
    }
  });

  // Handle number input changes
  inputMin.addEventListener('input', function() {
    const minVal = parseInt(inputMin.value) || 0;
    const maxVal = parseInt(inputMax.value);
    
    if (minVal <= maxVal - priceGap) {
      rangeMin.value = minVal;
      progress.style.left = (minVal / maxCollectionPrice) * 100 + "%";
      uncheckPriceRangeRadios();
      filterProducts();
    }
  });

  inputMax.addEventListener('input', function() {
    const minVal = parseInt(inputMin.value);
    const maxVal = parseInt(inputMax.value) || maxCollectionPrice;
    
    if (maxVal >= minVal + priceGap) {
      rangeMax.value = maxVal;
      progress.style.right = 100 - (maxVal / maxCollectionPrice) * 100 + "%";
      uncheckPriceRangeRadios();
      filterProducts();
    }
  });

  function uncheckPriceRangeRadios() {
    const priceRangeRadios = document.querySelectorAll('input[name="price-range"]');
    priceRangeRadios.forEach(radio => radio.checked = false);
  }

  // Handle custom select dropdowns
  customSelects.forEach(select => {
    const selected = select.querySelector('.select-selected');
    const itemsContainer = select.querySelector('.select-items');
    const originalLabel = selected.textContent;

    // Toggle dropdown
    selected.addEventListener('click', function(e) {
      e.stopPropagation();
      closeAllDropdowns(select);
      itemsContainer.classList.toggle('select-hide');
      selected.classList.toggle('active');
    });

    // Prevent closing when clicking inside the items container
    itemsContainer.addEventListener('click', function(e) {
      e.stopPropagation();
    });

    // Handle checkbox changes
    const checkboxes = select.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener('change', function() {
        updateSelectedText(select);
        filterProducts();
      });
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function() {
    closeAllDropdowns();
  });

  function closeAllDropdowns(exceptSelect = null) {
    customSelects.forEach(select => {
      if (select !== exceptSelect) {
        select.querySelector('.select-items').classList.add('select-hide');
        select.querySelector('.select-selected').classList.remove('active');
      }
    });
  }

  function updateSelectedText(select) {
    const selected = select.querySelector('.select-selected');
    const originalLabel = select.querySelector('.select-selected').getAttribute('data-original') || select.querySelector('.select-selected').textContent;
    selected.textContent = originalLabel;
  }

  function getSelectedValues(filterId) {
    const select = document.getElementById(filterId);
    const checkedBoxes = select.querySelectorAll('input[type="checkbox"]:checked');
    return Array.from(checkedBoxes).map(cb => cb.value.toLowerCase());
  }

  function getPriceRange() {
    return {
      min: parseInt(inputMin.value) || 0,
      max: parseInt(inputMax.value) || maxCollectionPrice
    };
  }

  function filterProducts() {
    const selectedData = getSelectedValues('data-filter');
    const selectedValidity = getSelectedValues('validity-filter');
    const priceRange = getPriceRange();
    let visibleCount = 0;
    

    const activeProductBenefit = {
      data: document.getElementById('collection_filter_data_only').checked,
      calls: document.getElementById('collection_filter_data_calls').checked
    };

    products.forEach(product => {
      const productData = product.getAttribute('data-custom-field').toLowerCase();
      const productValidity = product.getAttribute('validity-custom-field').toLowerCase();
      const jsPriceElement = product.querySelector('.jsPrice');
      const productPrice = jsPriceElement ? parseFloat(jsPriceElement.textContent.replace(/[^0-9.]/g, '')) : 0;
      const itemMetaData = product.getAttribute('data-product-meta-data');
      const itemMetaCalls = product.getAttribute('data-product-meta-calls');


      const matchesData = selectedData.length === 0 || selectedData.some(data => productData.includes(data));
      const matchesValidity = selectedValidity.length === 0 || selectedValidity.some(validity => productValidity.includes(validity));
      const matchesPrice = productPrice >= priceRange.min && productPrice <= priceRange.max;

      let matchesBenefit = true;
      
      if (activeProductBenefit.data && !activeProductBenefit.calls) {
        matchesBenefit = itemMetaCalls && itemMetaCalls.includes('not included') && !itemMetaCalls.includes('unlimited');
      }
      if (activeProductBenefit.calls) {
        matchesBenefit = itemMetaCalls && !itemMetaCalls.includes('not included');
      }

      if (matchesData && matchesValidity && matchesPrice && matchesBenefit) {
        product.style.display = '';
        visibleCount++;
      } else {
        product.style.display = 'none';
      }
    });


    if (noProductsMessage) {
      noProductsMessage.style.display = visibleCount === 0 ? 'none' : 'block';
    }
  }

  ['#collection_filter_data_only', '#collection_filter_data_calls'].forEach(id => {
    const element = document.querySelector(id);
    if (element) {
      element.addEventListener('change', () => filterProducts());
    }
  });

  // Initial filter
  filterProducts();
});



// Sort the Filters from Lowest to Highest
document.addEventListener('DOMContentLoaded', function () {


  
  // Function to sort numeric checkboxes
  function sortNumericCheckboxes(selector, parentSelector) {
    // Get all the checkbox elements based on the selector
    var checkboxes = document.querySelectorAll(selector);

    // Create an array to store the numeric values and their corresponding HTML elements
    var arrayToSort = [];

    checkboxes.forEach(function (checkbox) {
      // Extract the label value from the checkbox's data attribute
      var label = checkbox.getAttribute('data-filter') || checkbox.getAttribute('data-validity-filter');
      label = label.replace('custom_field-', '');
      var numericValue = parseInt(label); // Extract numeric part

      arrayToSort.push({
        value: numericValue, // Store the numeric value for sorting
        label: label,        // Store the original label (e.g., "10 Days")
        element: checkbox.parentElement // Store the checkbox HTML for reordering
      });
    });

    // Sort the array based on numeric values
    arrayToSort.sort(function (a, b) {
      return a.value - b.value;
    });

    // Get the parent container to append sorted elements
    var parentContainer = checkboxes[0].closest(parentSelector);

    // Find the container that wraps only the checkboxes
    var checkboxesContainer = document.createElement('div');
    checkboxesContainer.classList.add('filter__checkbox-container');

    // Append sorted elements to the new container
    arrayToSort.forEach(function (item) {
      checkboxesContainer.appendChild(item.element);
    });

    // Clear only the checkboxes in the parent container and re-add the sorted checkboxes
    parentContainer.querySelectorAll('.filter__checkbox-container').forEach(function(el) { el.remove(); });
    parentContainer.appendChild(checkboxesContainer);
  }

  // Sort customFieldsData
  sortNumericCheckboxes('.filter__checkbox input[data-filter^="custom_field-"]', '.filter__group');

  // Sort customFieldsValidity
  sortNumericCheckboxes('.filter__checkbox input[data-validity-filter^="custom_field-"]', '.filter__group');
});

// Add active class on the filter__checkbox when input is checked
filterCheckboxes.forEach(function(checkbox) {
  checkbox.addEventListener('change', function() {
    // Find the parent .filter__checkbox element
    var parentDiv = checkbox.closest('.filter__checkbox');
    
    if (checkbox.checked) {
      parentDiv.classList.add('active');
    } else {
      parentDiv.classList.remove('active');
    }
  });
});